<template>
  <div class="first-access">
    <div class="form-template">
      <form class="fields-container">
        <h2>{{ $t('first_access.title') }}</h2>
        <b-field
          label="Nome"
          :type="{ 'is-danger': errors.has('userName') }"
          :message="errors.first('userName')"
        >
          <b-input
            v-validate="'required'"
            name="Nome"
            :placeholder="commonPlaceholder"
            v-model.lazy="userName"
          />
        </b-field>
        <b-field
          label="CPF"
          :type="{ 'is-danger': errors.has('userCpf') }"
          :message="errors.first('userCpf')"
        >
          <b-input
            v-validate="'required'"
            name="cpf"
            :placeholder="commonPlaceholder"
            v-model.lazy="userCpf"
            v-mask="['###.###.###-##']"
          />
        </b-field>
        <b-field
          label="Email"
          :type="{ 'is-danger': errors.has('userEmail') }"
          :message="errors.first('userEmail')"
        >
          <b-input
            v-validate="'required'"
            name="Email"
            :placeholder="commonPlaceholder"
            v-model.lazy="userEmail"
          />
        </b-field>
        <b-field
          label="Celular"
          :type="{ 'is-danger': errors.has('userCel') }"
          :message="errors.first('userCel')"
          v-mask="['(##) ####-####', '(##) #####-####']"
        >
          <b-input
            v-validate="'required'"
            name="Celular"
            :placeholder="commonPlaceholder"
            v-model.lazy="userCel"
          />
        </b-field>
        <b-field
          :label="labelPassword"
          :type="{ 'is-danger': errors.has('userPassword') }"
          :message="errors.first('userPassword')"
        >
          <b-input
            v-model.lazy="userPassword"
            :placeholder="commonPlaceholder"
            name="password"
            v-validate="'required'"
            type="password"
            :data-vv-as="$t('fields_validator.password')"
            password-reveal
          />
        </b-field>
        <div class="columns column-submit">
          <div class="column">
            <div class="field">
              <button
                :disabled="!disabledButton"
                class="button button-primary"
                @click="sendNewUserInfo(), $emit('next-step')"
              >
                {{ $t('login.confirm_button') }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'FirstAccess',
  data() {
    return {
      labelRegister: this.$t('login.label-register'),
      labelPassword: this.$t('login.label-password'),
      mandatory: this.$t('login.mandatory'),
      commonPlaceholder: this.$t('placeholders.common'),
      isLoading: false,
      userName: '',
      userCpf: '',
      userEmail: '',
      userCel: '',
      userPassword: ''
    }
  },
  computed: {
    disabledButton() {
      return (
        this.userName &&
        this.userCpf &&
        this.userEmail &&
        this.userCel &&
        this.userPassword
      )
    }
  },
  methods: {
    ...mapActions(['setNewUserStateData']),

    sendNewUserInfo() {
      window.scrollTo(0, 0)
      const payload = {
        name: this.userName,
        cpf: this.userCpf.replace(/[^\d]+/g, ''),
        email: this.userEmail,
        cel: this.userCel,
        password: this.userPassword
      }
      this.setNewUserStateData(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.first-access {
  position: relative;
  top: 1.875rem;
  padding-bottom: 5rem;
  h2 {
    margin-bottom: 1.25rem;
    line-height: 1.5rem;
  }
  .field {
    margin-top: 1.3125rem;
  }
  .column-submit {
    margin-top: 0;
  }
  .form-template {
    .field {
      .label {
        color: var(--neutral-color-1);
        font-size: 0.875rem;
      }
      input {
        border-color: var(--neutral-color-4);
      }
    }
  }
  .link-reset-password {
    text-align: right;
    a {
      font-size: $caption + 2px;
      display: block;
      margin-top: 0.75rem;
      font-weight: $font-bold;
      line-height: $lh-caption;

      color: var(--secondary);
    }
  }
  .button[type='submit'] {
    width: 100%;
    min-height: 2.5rem;
    border: none;
    &[disabled] {
      background-color: var(--primary);
      border: none;
      opacity: 0.3;
    }
    &.button-primary {
      color: var(--white);

      background-color: var(--primary);
    }
  }
}
</style>
